<ul *ngIf="!isTopMenu" #mainDashMenu  class="nav flex-column">
  <li *ngFor="let menuItem of filteredMenus()" class="nav-item">
    <a class="nav-link align-middle" routerLinkActive="active" [routerLink]="[menuItem.LinkUrl]">
      <div class="nav-link-container align-self-center">
        <div class="nav-link-icon text-left">
          <mat-icon *ngIf="menuItem && menuItem.ImageName" svgIcon="{{menuItem?.ImageName}}"></mat-icon>
          <h4 class="d-inline">
          <adp-portal-menu [portalMenuItemKey]="menuItem?.Caption" [portalMenuKey] = "menuKey"></adp-portal-menu>
        </h4>
        </div>
      </div>
    </a>
  </li>


</ul>

 <!-- B2C Header Options -->
 <div *ngIf ="isTopMenu"  class="top_header_menu_container">
  <a *ngFor="let menuItem of filteredMenus()" class="top_header_menu_section" routerLinkActive="active" [routerLink]="[menuItem.LinkUrl]">
    <mat-icon svgIcon="{{menuItem?.ImageName}}"></mat-icon>
    <div id="portal_header_top_menu" class="top_header_menu_section_item">
      <adp-portal-menu [portalMenuItemKey]="menuItem?.Caption" [portalMenuKey] = "menuKey"></adp-portal-menu>
      </div>
 </a>
</div> 
